import { useAssessment } from "@/contexts/AssessmentContext/AssessmentContext";
export { Variant, PAGE_VARIANT } from "@/constants/variant";
import { Variant } from "@/constants/variant";

export function useVariant(): Variant {
  const { answers } = useAssessment();
  const isFemale = answers.some(
    (a) => a.questionId === "sex-at-birth" && a.answerId === "female",
  );
  return isFemale ? Variant.FEMALE : Variant.DEFAULT;
}
